import React, { useEffect, useState } from "react";
import HeaderCompo from "../../component/Header";
import { Button, Checkbox, DatePicker, Input, message, Table, Tooltip } from "antd";
import {
  CaretDownOutlined,
  DownloadOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { axiosInstance } from "../../utils/axiosInterceptor";
import * as XLSX from "xlsx";
import { render } from "@testing-library/react";
import './smsWorkflow.css'
import moment from "moment";
const SmsWorkflow = () => {
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [changedMap, setChangedMap] = useState({});
  const [isCheckBoxChange, setIsCheckBoxChange] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [isLoading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [pagination, setPagination] = useState(10);
  const [loadingCheck, setLoadingCheck] = useState(false);

  const [monthlyTrends,setMonthlyTrends] = useState([]);
  const [searchTextMonth,setSearchMonth] = useState('');
  const [isLoadingMonth,setIsLoadingMonth] = useState(false)
  const [fromDateMonth, setFromDateMonth] = useState("");
  const [toDateMonth, setToDateMonth] = useState("");
  const [paginationMonth, setPaginationMonth] = useState(10);

  /* ---------------- FETCH DATA ---------------- */

  const getDailyTrendsData = async (fromDate, toDate) => {
    let url = "/api/v2/powerbi/dailyTrends";
    if (fromDate && toDate) {
      url += `?fromDate=${fromDate}&toDate=${toDate}`;
    }

    setLoading(true);
    try {
      const response = await axiosInstance.get(url);
      const normalized = response?.data?.data.map((item) => ({
        ...item,
        email_enabled: Number(item.email_enabled),
        sms_enabled: Number(item.sms_enabled),
      }));

      setData(normalized);
      setTableData(normalized);
      setOriginalData(normalized);
      setChangedMap({});
      setIsCheckBoxChange(false);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
   const getMothlyTrendsData = async (fromDateMonth, toDateMonth) => {
    let url = "/api/v2/powerbi/monthlyTrends";
    if (fromDateMonth) {
      const fromMonth = formatMonthForApi(fromDateMonth);
      const toMonth = formatMonthForApi(toDateMonth)
      url += `?fromMonth=${fromMonth}&toMonth=${toMonth}`;
    }
    setIsLoadingMonth(true);
    try {
      const response = await axiosInstance.get(url);
      console.log(response,"Responseeee")
      setMonthlyTrends(response?.data?.data);
      // const normalized = response?.data?.data.map((item) => ({
      //   ...item,
      //   email_enabled: Number(item.email_enabled),
      //   sms_enabled: Number(item.sms_enabled),
      // }));

      // setData(normalized);
      // setTableData(normalized);
      // setOriginalData(normalized);
      // setChangedMap({});
      // setIsCheckBoxChange(false);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingMonth(false);
    }
  };

  useEffect(() => {
    getDailyTrendsData();
    getMothlyTrendsData()
  }, []);

  const handleCheckboxChange = (id, key, checked) => {
    const newValue = checked ? 1 : 0;

    setTableData((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [key]: newValue } : item))
    );

    setChangedMap((prev) => {
      const original = originalData.find((i) => i.id === id);

      if (original[key] === newValue) {
        const { [id]: _, ...rest } = prev;
        return rest;
      }

      return {
        ...prev,
        [id]: {
          ...(prev[id] || {
            id,
            email_enabled: original.email_enabled,
            sms_enabled: original.sms_enabled,
          }),
          [key]: newValue,
        },
      };
    });

    setIsCheckBoxChange(true);
  };

  const handleSave = async () => {
    const payload = {
      updates: Object.values(changedMap),
    };
    if (payload.updates?.length === 0) {
      message.info("There are no modified records to update.");
      setIsCheckBoxChange(false);
      return;
    }
    setLoadingCheck(true);
    try {
      await axiosInstance.post("/api/v2/powerbi/dailyTrends/enable", payload);

      message.success("Settings updated successfully");
      setChangedMap({});
      getDailyTrendsData();
      setIsCheckBoxChange(false);
    } catch (error) {
      message.error("Something went wrong");
    } finally {
      setLoadingCheck(false);
    }
  };

  const formatMonthForApi = (date) => {
  if (!date) return "";

  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");

  return `${year}-${month}`;
};

  /* ---------------- EXPORT ---------------- */

  const handleExport = () => {
    const headers = [
      "Account Number",
      "Account Name",
      "Loc Id",
      "Email",
      "phone",
      "Date",
      "Previous GCR %",
      "Current GCR %",
      "GCR Diff",
      "Previous SGCR %",
      "Current SGCR %",
      "SGCR Diff",
      "Previous GPR %",
      "Current GPR %",
      "GPR Diff",
      "Trend",
      "Trend Type",
      "Streak Days",
      // "Email Enabled",
      // "SMS Enabled",
    ];

    const rows = tableData?.map((item) => [
      item.accountId,
      item.accountName,
      item?.LocID,
      item.email,
      item?.phone,
      item.perf_date,
      item?.previous_gcr,
      item.gcr,
      item.delta_gcr,
      item?.previous_sgcr,
      item.sgcr,
      item.delta_sgcr,
      item?.previous_gpr,
      item?.gpr,
      item?.delta_gpr,
      item.trend,
      item.trendType,
      item.streakDays,
      // item?.email_enabled,
      // item?.sms_enabled,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Daily Trends");
    XLSX.writeFile(workbook, "DailyTrends.xlsx");
  };
  const handleExportMonth = ()=>{
     const headers = [
       "Loc Id",
      "Account Number",
      "Account Name",
      "Email",
      "phone",
      "Month",
      "Previous GCR %",
      "Current GCR %",
      "GCR Diff",
      "Previous SGCR %",
      "Current SGCR %",
      "SGCR Diff",
      "Previous GPR %",
      "Current GPR %",
      "GPR Diff",
      // "Trend",
      "Trend Type",
      // "Streak Days",
      // "Email Enabled",
      // "SMS Enabled",
    ];

    const rows = monthlyTrends?.map((item) => [
      item?.LocID,
      item.accountId,
      item.accountName,
      item.email,
      item?.phone,
      item.month,
      item?.previous_gcr,
      item.gcr,
      item.delta_gcr,
      item?.previous_sgcr,
      item.sgcr,
      item.delta_sgcr,
      item?.previous_gpr,
      item?.gpr,
      item?.delta_gpr,
      // item.trend,
      item.trendType,
      // item.streakDays,
      // item?.email_enabled,
      // item?.sms_enabled,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "monthly Trends");
    XLSX.writeFile(workbook, "MonthlyTrends.xlsx");
  };

  const columns = [
     {
      title: "Loc ID",
      dataIndex: "LocID",
      sorter: true,
      sorter: (a, b) => parseFloat(a.LocID || 0) - parseFloat(b.LocID || 0),
      render: (text, record) => (
        <span>
          {text}
        </span>
      ),
    },
    {
      title: "Account Number",
      dataIndex: "accountId",
      align:"right",
      sorter: true,
      sorter: (a, b) => String(a.accountId).localeCompare(String(b.accountId)),
      filteredValue: [searchText],
      onFilter: (value, record) => {
        return (
          String(record.accountName)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.email).toLowerCase().includes(value.toLowerCase()) ||
          String(record.accountId)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.phone).toLowerCase().includes(value.toLowerCase())
        );
      },
    },
    {
      title: "Account Name",
      dataIndex: "accountName",
      sorter: true,
      sorter: (a, b) =>
        String(a.accountName).localeCompare(String(b.accountName)),
      render: (text, record) => (
        <span
          className="cursor-pointer hover:underline hover:text-blue-800 transition"
          onClick={() => {
            const formattedAccountId = record.accountId
              ?.toString()
              .startsWith("0")
              ? record.accountId.toString().replace(/^0+/, "")
              : record.accountId;

            const params = new URLSearchParams({
              accountId: Number(formattedAccountId),
              accountName: record.accountName,
            }).toString();

            window.open(`/react-dashboard?${params}`, "_blank");
          }}
        >
          {text}
        </span>
      ),
    },
   

    { title: "Email", dataIndex: "email",
      sorter: true,
      sorter: (a, b) => String(a.email).localeCompare(String(b.email)),
      render: (v) => ((v === null || v==="null" || v ==="" || v== undefined) ? '-' : v)
     },
    { title: "Phone", dataIndex: "phone", align: "right",
      render: (v) => ((v === null || v==="null" || v ==="" || v== undefined) ? '-' : v)
    },
    {
      title: "Date",
      dataIndex: "perf_date",
      sorter: true,
      sorter: (a, b) => String(a.perf_date).localeCompare(String(b.perf_date)),
    },
    {
  title: "GCR",
  children: [
     {
      title: "Previous GCR %",
      dataIndex: "previous_gcr",
      align: "right",
      sorter: true,
      sorter: (a, b) => parseFloat(a.previous_gcr || 0) - parseFloat(b.previous_gcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "Current GCR %",
      dataIndex: "gcr",
      align: "right",
      sorter: true,
      sorter: (a, b) => parseFloat(a.gcr || 0) - parseFloat(b.gcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "GCR Diff",
      dataIndex: "delta_gcr",
      align: "right",
      sorter: true,
      sorter: (a, b) =>
        parseFloat(a.delta_gcr || 0) - parseFloat(b.delta_gcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
  ],
},

  {
  title: "SGCR",
  children: [
    {
      title: "Previous SGCR %",
      dataIndex: "previous_sgcr",
      align: "right",
      sorter: true,
      sorter: (a, b) => parseFloat(a.previous_sgcr || 0) - parseFloat(b.previous_sgcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "Current SGCR %",
      dataIndex: "sgcr",
      align: "right",
      sorter: true,
      sorter: (a, b) => parseFloat(a.sgcr || 0) - parseFloat(b.sgcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SGCR Diff",
      dataIndex: "delta_sgcr",
      align: "right",
      sorter: true,
      sorter: (a, b) =>
        parseFloat(a.delta_sgcr || 0) - parseFloat(b.delta_sgcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
  ],
},
//  {
//   title: "GPR",
//   children: [
//      {
//       title: "Previous GPR %",
//       dataIndex: "previous_gpr",
//       align: "right",
//       sorter: true,
//       sorter: (a, b) => parseFloat(a.previous_gpr || 0) - parseFloat(b.previous_gpr || 0),
//       render: (val) =>
//         val === undefined || val === "" || val === "null" ? "-" : val,
//     },
    {
      title: "GPR %",
      dataIndex: "gpr",
      align: "right",
      sorter: true,
      sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
//     {
//       title: "GPR Diff",
//       dataIndex: "delta_gpr",
//       align: "right",
//       sorter: true,
//       sorter: (a, b) =>
//         parseFloat(a.delta_gpr || 0) - parseFloat(b.delta_gpr || 0),
//       render: (val) =>
//         val === undefined || val === "" || val === "null" ? "-" : val,
//     },
//   ],
// },

    {
      title: "Trend",
      dataIndex: "trend",
      render: (value) =>
        value === "0" ? (
          <span className="text-red-500">
            <CaretDownOutlined />
          </span>
        ) : (
          value
        ),
    },
    {
      title: "Trend Type",
      dataIndex: "trendType",
      render: (text) =>
        text === "0"
          ? "GCR down"
          : text === "1"
          ? "SGCR down"
          : "Both SGCR and GCR down",
    },
    { title: (
    <div className="flex items-center justify-end gap-2">
      <span>Streak Days</span>
      <Tooltip title="This shows how many consecutive days the data has been decreasing since last week">
        <InfoCircleOutlined className="text-gray-100 hover:text-blue-600 cursor-pointer" style={{ fontSize:15 }} />
      </Tooltip>
    </div>
  ), 
  dataIndex: "streakDays",align:"right" },

    // {
    //   title: "Email Enable",
    //   dataIndex: "email_enabled",
    //   render: (_, record) => (
    //     <Checkbox
    //       checked={Boolean(record.email_enabled)}
    //       onChange={e =>
    //         handleCheckboxChange(
    //           record.id,
    //           "email_enabled",
    //           e.target.checked
    //         )
    //       }
    //     />
    //   ),
    // },
    // {
    //   title: "SMS Enabled",
    //   dataIndex: "sms_enabled",
    //   render: (_, record) => (
    //     <Checkbox
    //       checked={Boolean(record.sms_enabled)}
    //       onChange={e =>
    //         handleCheckboxChange(
    //           record.id,
    //           "sms_enabled",
    //           e.target.checked
    //         )
    //       }
    //     />
    //   ),
    // },
  ];

  const columnsMonth = [
    {
      title: "Loc ID",
      dataIndex: "LocID",
      sorter: true,
      sorter: (a, b) => parseFloat(a.LocID || 0) - parseFloat(b.LocID || 0),
      render: (text, record) => (
        <span>
          {text}
        </span>
      ),
    },
    {
      title: "Account Number",
      dataIndex: "accountId",
      align:"right",
      sorter: true,
      sorter: (a, b) => String(a.accountId).localeCompare(String(b.accountId)),
      filteredValue: [searchTextMonth],
      onFilter: (value, record) => {
        return (
          String(record.accountName)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.email).toLowerCase().includes(value.toLowerCase()) ||
          String(record.accountId)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.phone).toLowerCase().includes(value.toLowerCase())
        );
      },
    },
    {
      title: "Account Name",
      dataIndex: "accountName",
      sorter: true,
      sorter: (a, b) =>
        String(a.accountName).localeCompare(String(b.accountName)),
      render: (text, record) => (
        <span
          className="cursor-pointer hover:underline hover:text-blue-800 transition"
          onClick={() => {
            const formattedAccountId = record.accountId
              ?.toString()
              .startsWith("0")
              ? record.accountId.toString().replace(/^0+/, "")
              : record.accountId;

            const params = new URLSearchParams({
              accountId: Number(formattedAccountId),
              accountName: record.accountName,
            }).toString();

            window.open(`/react-dashboard?${params}`, "_blank");
          }}
        >
          {text}
        </span>
      ),
    },
    

    { title: "Email", dataIndex: "email",
      sorter: true,
      sorter: (a, b) => String(a.email).localeCompare(String(b.email)),
      render: (v) => ((v === null || v==="null" || v ==="" || v== undefined) ? '-' : v)
     },
    { title: "Phone", dataIndex: "phone", align: "right",
      render: (v) => ((v === null || v==="null" || v ==="" || v== undefined) ? '-' : v)
    },
    {
      title: "Month",
      dataIndex: "month",
      sorter: true,
      sorter: (a, b) => String(a.perf_date).localeCompare(String(b.perf_date)),
      render: (month) => moment(month, "YYYY-MM").format("MM-YYYY"),
    },
    {
  title: "GCR",
  children: [
     {
      title: "Previous GCR %",
      dataIndex: "previous_gcr",
      align: "right",
      sorter: true,
      sorter: (a, b) => parseFloat(a.previous_gcr || 0) - parseFloat(b.previous_gcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "Current GCR %",
      dataIndex: "gcr",
      align: "right",
      sorter: true,
      sorter: (a, b) => parseFloat(a.gcr || 0) - parseFloat(b.gcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "GCR Diff",
      dataIndex: "delta_gcr",
      align: "right",
      sorter: true,
      sorter: (a, b) =>
        parseFloat(a.delta_gcr || 0) - parseFloat(b.delta_gcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
  ],
},

  {
  title: "SGCR",
  children: [
    {
      title: "Previous SGCR %",
      dataIndex: "previous_sgcr",
      align: "right",
      sorter: true,
      sorter: (a, b) => parseFloat(a.previous_sgcr || 0) - parseFloat(b.previous_sgcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "Current SGCR %",
      dataIndex: "sgcr",
      align: "right",
      sorter: true,
      sorter: (a, b) => parseFloat(a.sgcr || 0) - parseFloat(b.sgcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SGCR Diff",
      dataIndex: "delta_sgcr",
      align: "right",
      sorter: true,
      sorter: (a, b) =>
        parseFloat(a.delta_sgcr || 0) - parseFloat(b.delta_sgcr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
  ],
},
 {
  title: "GPR",
  children: [
     {
      title: "Previous GPR %",
      dataIndex: "previous_gpr",
      align: "right",
      sorter: true,
      sorter: (a, b) => parseFloat(a.previous_gpr || 0) - parseFloat(b.previous_gpr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "Current GPR %",
      dataIndex: "gpr",
      align: "right",
      sorter: true,
      sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "GPR Diff",
      dataIndex: "delta_gpr",
      align: "right",
      sorter: true,
      sorter: (a, b) =>
        parseFloat(a.delta_gpr || 0) - parseFloat(b.delta_gpr || 0),
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
  ],
},

    // {
    //   title: "Trend",
    //   dataIndex: "trend",
    //   render: (value) =>
    //     value === "0" ? (
    //       <span className="text-red-500">
    //         <CaretDownOutlined />
    //       </span>
    //     ) : (
    //       value
    //     ),
    // },
    {
      title: "Trend Type",
      dataIndex: "trendType",
      render: (text) =>
        text === "0"
          ? "GCR down"
          : text === "1"
          ? "SGCR down"
          : "Both SGCR and GCR down",
    },
    // { title: "Streak Days", dataIndex: "streakDays",align:"right" },
  ]

  const handleSearch = (val) => {
    setSearchText(val);
    console.log(val, "vallll");
    const filtered = tableData?.filter(
      (user) =>
        user?.accountName?.toLowerCase().includes(searchText.toLowerCase()) ||
        String(user?.accountId || "").includes(searchText.toLowerCase()) ||
        String(user?.email || "").includes(searchText.toLowerCase())
    );
    setTableData(filtered);
  };

  return (
    <div>
      <HeaderCompo initialColor="#000833" />

      <div className="p-6">
        <div className="flex justify-between mb-4">
          <h1 className="text-2xl font-bold">DAILY TREND REVERSAL (GCR/ SGCR)</h1>
          <Button icon={<DownloadOutlined />} onClick={handleExport}>
            Export
          </Button>
        </div>

        {/* <div className="flex gap-4 mb-4">
          <DatePicker
            value={fromDate ? dayjs(fromDate) : null}
            onChange={d => setFromDate(d?.toDate())}
          />
          <DatePicker
            value={toDate ? dayjs(toDate) : null}
            onChange={d => setToDate(d?.toDate())}
          />
          <Button
            icon={<FilterOutlined />}
            type="primary"
            onClick={() => getDailyTrendsData(fromDate, toDate)}
          >
            Filter
          </Button>
        </div> */}
        {/* <div className="flex flex-col w-full md:flex-row items-start md:items-center gap-4 mb-4 justify-between">
            <div className="flex flex-col sm:flex-col md:flex-row justify-start items-center gap-2">

             <div className="flex">
             <div className="flex items-center gap-2 mr-4">
               <span className="font-medium text-gray-600">From</span>
               <DatePicker
                 value={fromDate ? dayjs(fromDate) : null}
                 format="MM-DD-YYYY"
                 className="w-full md:w-[250px]"
                 placeholder="Select Start Date"
                 onChange={(date) => {
                   if (date) {
                     const jsDate = new Date(date.toDate());
                     jsDate.setHours(0, 0, 0, 0);
                     setFromDate(jsDate);
                   }
                 }}
               />
             </div>
             <div className="flex items-center gap-2">
               <span className="font-medium text-gray-600">To</span>
               <DatePicker
                 value={toDate ? dayjs(toDate) : null}
                 format="MM-DD-YYYY"
                 className="w-full md:w-[250px]"
                 placeholder="Select End Date"
                 onChange={(date) => {
                   if (date) {
                     const jsDate = new Date(date.toDate());
                     jsDate.setHours(23, 59, 59, 999);
                     setToDate(jsDate);
                   }
                 }}
               />
             </div>
             </div>
             <Button
               type="primary"
               className="w-full md:w-[100px]"
               icon={<FilterOutlined />}
               onClick={() => {
                 getDailyTrendsData(fromDate, toDate);
               }}
             >
               Filter
             </Button>
            </div>

             <div className="flex items-center gap-2">
                <Input
                  placeholder="Search ..."
                  suffix={<SearchOutlined />}
                  // value={searchText}
                  // onChange={handleSearch}
                  // // onChange={(e) => setSearchText(e.target.value)}
                  className="w-full sm:w-[300px]"
                  style={{
                    border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  }}
                />
               <Button >
                  Search
               </Button>
             </div>
           </div> */}
        <div className="flex flex-col gap-4 mb-4 w-full">
          {/* Top Row – Dates + Filter */}
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 justify-between w-full">
            <div className="flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-3 w-full lg:w-auto">
              <div className="flex gap-4">
                <div className="flex flex-row sm:flex-row items-start sm:items-center gap-2">
                  <span className="font-medium text-gray-600">From</span>
                  <DatePicker
                    value={fromDate ? dayjs(fromDate) : null}
                    format="MM-DD-YYYY"
                    className="w-full sm:w-[220px]"
                    placeholder="Select Start Date"
                    onChange={(date) => {
                      if (date) {
                        const jsDate = new Date(date.toDate());
                        jsDate.setHours(0, 0, 0, 0);
                        setFromDate(jsDate);
                      }
                    }}
                  />
                </div>

                <div className="flex flex-row sm:flex-row items-start sm:items-center gap-2">
                  <span className="font-medium text-gray-600">To</span>
                  <DatePicker
                    value={toDate ? dayjs(toDate) : null}
                    format="MM-DD-YYYY"
                    className="w-full sm:w-[220px]"
                    placeholder="Select End Date"
                    onChange={(date) => {
                      if (date) {
                        const jsDate = new Date(date.toDate());
                        jsDate.setHours(23, 59, 59, 999);
                        setToDate(jsDate);
                      }
                    }}
                  />
                </div>
              </div>

              <Button
                type="primary"
                className="w-full sm:w-auto px-6"
                icon={<FilterOutlined />}
                onClick={() => getDailyTrendsData(fromDate, toDate)}
              >
                Filter
              </Button>
            </div>

            {/* Search Section */}
            <div className="flex flex-row sm:flex-row items-stretch sm:items-center gap-2 w-full lg:w-auto">
              <Input
                placeholder="Search..."
                suffix={<SearchOutlined />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="w-full sm:w-[280px]"
                style={{
                  border: "1px solid var(--Primary-Dark-Blue, #000833)",
                }}
              />
              {/* <Button className="w-[100px] sm:w-auto">Search</Button> */}
            </div>
          </div>
        </div>

        {isCheckBoxChange && (
          <div className="flex justify-end mb-3">
            <Button type="primary" loading={loadingCheck} onClick={handleSave}>
              Save Changes
            </Button>
          </div>
        )}

        <Table
          columns={columns}
          dataSource={tableData}
          // pagination={false}
          pagination={{
            pageSize: pagination,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} accounts`,
            onShowSizeChange: (current, size) => {
              setPagination(size);
            },
          }}
          // onChange={handleTableChange}
          loading={isLoading}
          scroll={{ x: "max-content" }}
          rowKey="trans_id"
          size="middle"
          className="custom-tablenew user-tblNew grouped-metrics-table"
        />
      </div>

      <div className="p-6">
        <div className="flex justify-between mb-4">
          <h1 className="text-2xl font-bold">GPR - Monthly Trend</h1>
          <Button icon={<DownloadOutlined />} onClick={handleExportMonth}>
            Export
          </Button>
        </div>
        <div className="flex flex-col gap-4 mb-4 w-full">
          {/* Top Row – Dates + Filter */}
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 justify-between w-full">
            <div className="flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-3 w-full lg:w-auto">
              <div className="flex gap-4">
                <div className="flex flex-row sm:flex-row items-start sm:items-center gap-2">
                  <span className="font-medium text-gray-600">From</span>
                  <DatePicker
                  picker="month"
                    value={fromDateMonth ? dayjs(fromDateMonth) : null}
                    format="MM-YYYY"
                    className="w-full sm:w-[220px]"
                    placeholder="Select Month"
                    onChange={(date) => {
                      if (date) {
                        const jsDate = date.startOf("month").toDate(); // First day of selected month
                        setFromDateMonth(jsDate);
                      }
                    }}
                  />
                </div>

                <div className="flex flex-row sm:flex-row items-start sm:items-center gap-2">
                  <span className="font-medium text-gray-600">To</span>
                  <DatePicker
                   picker="month"
                    value={toDateMonth ? dayjs(toDateMonth) : null}
                    format="MM-YYYY"
                    className="w-full sm:w-[220px]"
                    placeholder="Select Month"
                    onChange={(date) => {
                      if (date) {
                        const jsDate = date.startOf("month").toDate();
                        setToDateMonth(jsDate);
                      }
                    }}
                  />
                </div>
              </div>

              <Button
                type="primary"
                className="w-full sm:w-auto px-6"
                icon={<FilterOutlined />}
                onClick={() => getMothlyTrendsData(fromDateMonth,toDateMonth)}
              >
                Filter
              </Button>
            </div>

            {/* Search Section */}
            <div className="flex flex-row sm:flex-row items-stretch sm:items-center gap-2 w-full lg:w-auto">
              <Input
                placeholder="Search..."
                suffix={<SearchOutlined />}
                value={searchTextMonth}
                onChange={(e) => setSearchMonth(e.target.value)}
                className="w-full sm:w-[280px]"
                style={{
                  border: "1px solid var(--Primary-Dark-Blue, #000833)",
                }}
              />
              {/* <Button className="w-[100px] sm:w-auto">Search</Button> */}
            </div>
          </div>
        </div>

        {/* {isCheckBoxChange && (
          <div className="flex justify-end mb-3">
            <Button type="primary" loading={loadingCheck} onClick={handleSave}>
              Save Changes
            </Button>
          </div>
        )} */}

        <Table
          columns={columnsMonth}
          dataSource={monthlyTrends}
          // pagination={false}
          pagination={{
            pageSize: paginationMonth,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} accounts`,
            onShowSizeChange: (current, size) => {
              setPaginationMonth(size);
            },
          }}
          // onChange={handleTableChange}
          loading={isLoadingMonth}
          scroll={{ x: "max-content" }}
          rowKey="trans_id"
          size="middle"
          className="custom-tablenew user-tblNew grouped-metrics-table"
        />
      </div>
    </div>
  );
};

export default SmsWorkflow;
